module.exports = __webpack_public_path__ + "assets/images/pricing.fa69f114.jpg";